var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imagebox",style:(Object.assign({}, _vm.styles.height)),attrs:{"title":_vm.title},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"imagebox-bg",class:_vm.classes,style:(_vm.styles)}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }